import { axiosGet } from "../../Helpers";

export const loadIndustriesTypes = async (setLoading) => {
  setLoading(true);
  const response = await axiosGet("industryType/listIndustryType");
  setLoading(false);
  const data = response.data?.data;
  data.map((item, index) => {
    item.id = index + 1;
  });
  return data;
};

